module.exports = __webpack_public_path__ + "static/media/6512.df5670ca.jpg";